export const BINARY_ANSWER_NO = "2";
export const BINARY_ANSWER_YES = "1";

export const QUESTIONS_PAGE_STATE_KEY = "QUESTIONS_PAGE_STATE";

// one day, in seconds
export const SECONDS_BETWEEN_REANSWER = 60 * 60 * 24;

export const IMPORTANCES = {
	VERY: "VERY", // 1
	SOMEWHAT: "SOMEWHAT", // 3
	LITTLE: "LITTLE", // 4
	IRRELEVANT: "IRRELEVANT", // 5
};



// WEBPACK FOOTER //
// ./src/apps/questions/util/constants.js